import './i18n/init';
import React, { useEffect, lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation
} from 'react-router-dom';
import WelcomePage from 'views/WelcomePage';
import 'styles/App.scss';
import LandingPage from 'views/LandingPage';
import DomainLayout from 'components/DomainLayout';

const Introduction = lazy(() => import('views/Introduction'));
const QuestionSet = lazy(() => import('views/QuestionSet'));
const SearchReport = lazy(() =>
  import('views/updateReportingParty/SearchReport')
);
const NewInformation = lazy(() =>
  import('views/updateReportingParty/NewInformation')
);
const UniqueCode = lazy(() => import('views/UniqueCode'));
const UpdatedReportingParty = lazy(() =>
  import('views/updateReportingParty/UpdatedReportingParty')
);
const ReportStatus = lazy(() => import('views/reportStatus/ReportStatus'));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollableEl = document.querySelector('.t-main-layout');
    scrollableEl?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    const root = document.querySelector('.root');
    root.classList.add('fade-in');
  }, []);

  return (
    <main className="root">
      <Router>
        <ScrollToTop />
        <Suspense fallback={<main />}>
          <Routes>
            <Route path="" element={<LandingPage />} />
            <Route path="/:domain" element={<DomainLayout />}>
              <Route index element={<WelcomePage />} />
              <Route path="introduction" element={<Introduction />} />
              <Route path="questionset" element={<QuestionSet />} />
              <Route path="report-id" element={<SearchReport />} />
              <Route path="new-information" element={<NewInformation />} />
              <Route
                path="updated-report"
                element={<UpdatedReportingParty />}
              />
              <Route
                path="review-id"
                element={<SearchReport currentOperation="getStatus" />}
              />
              <Route path="report-status" element={<ReportStatus />} />
              <Route path="uniquecode" element={<UniqueCode />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </main>
  );
}

export default App;
